import { render, staticRenderFns } from "./TdFade.vue?vue&type=template&id=1871cf58&scoped=true"
import script from "./TdFade.vue?vue&type=script&lang=js"
export * from "./TdFade.vue?vue&type=script&lang=js"
import style0 from "./TdFade.vue?vue&type=style&index=0&id=1871cf58&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1871cf58",
  null
  
)

export default component.exports